/// <reference types="swiper"/>
import 'core-js/stable/object/assign';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs, EffectFade } from 'swiper/modules';
import { Data } from "../utils/data";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "swiper/css/effect-fade";
class SwiperSlider {
    constructor(config) {
        this.options = {};
        this.element = config.element;
        Object.assign(this.options, this.optionsFromDataAttributes());
        if (config.options) {
            Object.assign(this.options, config.options);
        }
        this.loadModules();
        this.run();
    }
    optionsFromDataAttributes() {
        const options = {};
        Object.assign(options, this.element.dataset);
        for (const optionsKey in options) {
            options[optionsKey] = Data.getData(options[optionsKey]);
        }
        return options;
    }
    loadModules() {
        if (!this.options.hasOwnProperty('modules')) {
            this.options.modules = [];
        }
        for (const optionsKey in this.options) {
            if (optionsKey === 'autoplay') {
                this.options.modules.push(Autoplay);
            }
            if (optionsKey === 'navigation') {
                this.options.modules.push(Navigation);
            }
            if (optionsKey === 'pagination') {
                this.options.modules.push(Pagination);
            }
            if (optionsKey === 'effect') {
                if (typeof this.options[optionsKey] !== 'undefined'
                    && this.options[optionsKey] === 'fade') {
                    this.options.modules.push(EffectFade);
                }
            }
            if (optionsKey === 'thumbs') {
                if (typeof this.options[optionsKey].el !== 'undefined') {
                    const thumbSlider = document.querySelector(this.options[optionsKey].el);
                    if (thumbSlider !== null) {
                        const thumbSliderInstance = new SwiperSlider({
                            element: thumbSlider
                        }).getInstance();
                        this.options[optionsKey] = {
                            swiper: thumbSliderInstance
                        };
                        this.options.modules.push(Thumbs);
                    }
                }
            }
        }
        return;
    }
    getInstance() {
        return this.instance;
    }
    run() {
        // console.log(this.options);
        this.instance = new Swiper(this.element, this.options);
        return this;
    }
}
export { SwiperSlider };
